import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { TokenService } from './token.service';
import { hasAnyRole } from './roles.constants';

export const roleGuard: CanActivateFn = (route, _state) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);

  const requiredRoles = route.data?.['roles'] as string[] | undefined;

  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  const userRoles = tokenService.getRoles();

  if (hasAnyRole(userRoles, requiredRoles)) {
    return true;
  }

  return router.parseUrl('/');
};
